/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import EmployeeDetailsBody from "../../../Employee/EmployeeDetailsBody";
import EmployeeDetailsFromContractorFlowContractApp from "../../Functionality/EmployeeDetailsFlows/EmployeeDetailsFromContractorFlowContractApp";

const EmployeeDetailsFromContractorFlowContract = (props) => {
    const {  t,
        contractId,
        contractorId,
        unlinkShow,
        setUnlinkShow,
        deleteEmployeeShow,
        setDeleteEmployeeShow} = EmployeeDetailsFromContractorFlowContractApp(props);

    return (
        <>
            <HeadTittle name={t('details1')} link={routes.contractor.contractDetails + contractId}/>
            <EmployeeDetailsBody
                disabled={true}
                deleteEmployeeShow={deleteEmployeeShow}
                setDeleteEmployeeShow={setDeleteEmployeeShow}
                unlinkShow={unlinkShow}
                setUnlinkShow={setUnlinkShow}
                showBtnDeleteDoc={false}
            />
        </>
    );
};

export default EmployeeDetailsFromContractorFlowContract;
